import { createSlice } from '@reduxjs/toolkit';

function uuidv4() {
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16),
  );
}

const checkInfoPane = () => {
  return localStorage.getItem('IsInfoPaneExpanded');
};

const setIsInfoPaneExpanded = (val) => {
  localStorage.setItem('IsInfoPaneExpanded', val);
};

export const INFO_PANE_PAGES = {
  'patient_page': 'patient_page',
  'metrics': 'metrics',
  'program': 'program',
};

const _openInfoPane = (state, action) => {
  state.isInfoPaneExpanded = true;
  setIsInfoPaneExpanded(true);
  const newPage = { ...action.payload, uuid: uuidv4() };
  let newHistory = [...state.history, newPage];
  const historyUuids = state.history.map(({ uuid }) => uuid);
  if (state.currentPage?.uuid) {
    const indexOfCurrentPageInHistory = historyUuids.findIndex((uuid) => uuid === state.currentPage.uuid);
    if (indexOfCurrentPageInHistory >= 0 && indexOfCurrentPageInHistory < state.history.length - 1) {
      newHistory = [...state.history.slice(0, indexOfCurrentPageInHistory + 1), newPage];
    }
  }
  if (newHistory.length > 10) {
    newHistory.shift();
  }
  newPage.indexInHistory = newHistory.length - 1;
  state.history = newHistory;
  state.currentPage = newPage;
};

const _openLastPage = (state) => {
  if (state.history.length > 0) {
    state.isInfoPaneExpanded = true;
    state.currentPage = state.history[state.history.length - 1];
  }
};
const _toggleIsInfoPaneExpanded = (state, action) => {
  const newIsInfoPaneExpanded = action.payload !== undefined ? action.payload : !state.isInfoPaneExpanded;
  setIsInfoPaneExpanded(newIsInfoPaneExpanded);
  state.isInfoPaneExpanded = newIsInfoPaneExpanded;
};

export const infoPaneSlice = createSlice({
  name: 'infoPane',
  initialState: {
    currentPage: {
      uuid: null,
      indexInHistory: -1,
      currentPageName: null,
      currentPageContext: null,
      currentPageData: null,
    },

    history: [],

    isInfoPaneExpanded: false,
  },
  reducers: {
    getAndSetIsInfoPaneExpanded: (state) => {
      if (checkInfoPane() === 'false') {
        state.isInfoPaneExpanded = false;
      }
    },
    toggleIsInfoPaneExpanded: _toggleIsInfoPaneExpanded,
    openInfoPane: _openInfoPane,
    openPreviousPageFromHistory: (state) => {
      const historyUuids = state.history.map(({ uuid }) => uuid);
      const indexOfCurrentPageInHistory = historyUuids.findIndex((uuid) => uuid === state.currentPage.uuid);
      state.currentPage = state.history[indexOfCurrentPageInHistory - 1];
    },
    openNextPageFromHistory: (state) => {
      const historyUuids = state.history.map(({ uuid }) => uuid);
      const indexOfCurrentPageInHistory = historyUuids.findIndex((uuid) => uuid === state.currentPage.uuid);
      state.currentPage = state.history[indexOfCurrentPageInHistory + 1];
    },
    closeInfoPane: (state) => {
      setIsInfoPaneExpanded(false);
      state.isInfoPaneExpanded = false;

      state.currentPage = {
        uuid: null,
        currentPageName: null,
        currentPageContext: null,
        currentPageData: null,
      };
    },
    setCurrentPageData: (state, action) => {
      state.currentPage.currentPageData = action.payload;
    },
    setCurrentPageContext: (state, action) => {
      state.currentPage.currentPageContext = action.payload;
    },
    openLastPage: _openLastPage,
    openPatientPane: (state, action) => {
      const newData = action.payload;
      const currentPage = state.currentPage;
      const history = state.history;
      const isPaneAlreadyOpenForThisInfo = (currentPage?.currentPageName === INFO_PANE_PAGES.patient_page && currentPage?.currentPageContext?.patientUUID === newData.patientUUID)
        || (currentPage?.currentPageName === INFO_PANE_PAGES.patient_page && !currentPage?.uuid && history.length
          && (history[history.length - 1]?.currentPageContext?.patientUUID === newData.patientUUID));
      if ((!history.length && (currentPage?.currentPageName && currentPage?.currentPageName !== INFO_PANE_PAGES.patient_page)) || !isPaneAlreadyOpenForThisInfo) {
        _openInfoPane(state, {
          payload: {
            currentPageName: INFO_PANE_PAGES.patient_page,
            currentPageContext: newData,
          },
        });
      } else if (isPaneAlreadyOpenForThisInfo && !currentPage?.currentPageName) {
        _openLastPage(state);
      } else {
        _toggleIsInfoPaneExpanded(state, { payload: true });
      }
    },
    openProgramPane: (state, action) => {
      const newData = action.payload;
      const currentPage = state.currentPage;
      const history = state.history;

      const isPaneAlreadyOpenForThisInfo = (currentPage?.currentPageName === INFO_PANE_PAGES.program && currentPage?.currentPageContext?.value === newData.value)
        || (currentPage?.currentPageName === INFO_PANE_PAGES.program && !currentPage?.uuid && history.length
          && (history[history.length - 1]?.currentPageContext?.value === newData.value));

      if ((!history.length && (currentPage?.currentPageName && currentPage?.currentPageName !== INFO_PANE_PAGES.program)) || !isPaneAlreadyOpenForThisInfo) {
        _openInfoPane(state, {
          payload: {
            currentPageName: INFO_PANE_PAGES.program,
            currentPageContext: newData,
          },
        });
      } else if (isPaneAlreadyOpenForThisInfo && !currentPage?.currentPageName) {
        _openLastPage(state);
      } else {
        _toggleIsInfoPaneExpanded(state, { payload: true });
      }
    },
  },
});

export const {
  getAndSetIsInfoPaneExpanded,
  toggleIsInfoPaneExpanded,
  openInfoPane,
  openLastPage,
  openPatientPane,
  closeInfoPane,
  setCurrentPageData,
  openPreviousPageFromHistory,
  openNextPageFromHistory,
  setCurrentPageContext,
  openProgramPane,
} = infoPaneSlice.actions;

export default infoPaneSlice.reducer;
